<template>
  <div class="bread-wrapper">
    <Breadcrumb>
<!--      <BreadcrumbItem>-->
<!--        <IconFont type="icon-huochezhanxiao" />-->
<!--        <span>12306</span></BreadcrumbItem-->
<!--      >-->
      <BreadcrumbItem
        ><IconFont :type="currentPath?.icon" color="black" />
        <span>{{ currentPath?.label }}</span></BreadcrumbItem
      >
    </Breadcrumb>
  </div>
</template>

<script setup>
import { Breadcrumb, BreadcrumbItem } from 'ant-design-vue'
import { useRoute } from 'vue-router'
import { routes } from '@/router'
import { watch, ref } from 'vue'
import IconFont from '@/components/icon-font'
const route = useRoute()
const currentPath = ref(null)

watch(
  () => route.path,
  (newValue) => {
    currentPath.value = routes.find((item) => item?.path === newValue)
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
::v-deep {
  .ant-breadcrumb {
    margin-bottom: 14px;
    padding: 10px 14px;
    border: 1px solid #e6edf8;
    border-radius: 10px;
    background: #f8fbff;
  }

  .ant-breadcrumb-link {
    color: #475569;
  }

  .ant-breadcrumb > span:last-child .ant-breadcrumb-link {
    color: #1d4ed8;
    font-weight: 600;
  }
}
</style>
